export const getEnvConfig = (): { [key: string]: string } => {
  if (typeof window !== 'undefined') {
    return window['__env__'] || {};
  }

  return {};
};
